module.exports = __webpack_public_path__ + "static/media/octagonal_stay_plate.8408dda9.webp";